import { BudgetRepository } from "@project/data/repositories/budget.repository";
import { inject, injectable } from "inversify";

export interface ExpenseSubtypeOption {
    value: string;
    label: string;
}

@injectable()
export class GetCategoryGroupExpenseSubtypesUseCase {
    constructor(
        @inject(BudgetRepository)
        private readonly budgetRepository: BudgetRepository,
    ) { }

    async execute(typeId?: string): Promise<ExpenseSubtypeOption[]> {
        const result = await this.budgetRepository.getCategoryGroupExpenseSubtypes(typeId);
        return result.getOrElse([]);
    }
}
